t = require('views/internal/teacup-with-helpers')('shortcuts')

shortcutEntry = (keys, name, descFn) ->
  t.div '.shortcut-list-item', ->
    t.h3 '.shortcut-list-item-header', ->
      t.format name

    t.div '.shortcut-list-item-keys', ->
      for keyText in keys
        t.span '.keyboard-key', ->
          t.text keyText

    t.div '.short-list-item-desc', ->
      descFn()

module.exports = ->
  t.div '.window-main-col', ->
    t.div '.window-header.u-clearfix', ->
      t.span '.window-header-icon.icon-lg.icon-information'
      t.h2 '.window-title', ->
        t.format 'keyboard-shortcuts'

    t.div '.shortcut-list.markeddown', ->

      t.hr()

      shortcutEntry ["←", "↓ / J", "↑ / K", "→"], 'navigate-cards', ->
        t.p ->
          t.format 'pressing-the-arrow-keys-will-select-adjacent-cards-on-a-board-pressing-j-will-select-the-card-below-the-current-card-pressing-k-will-select-the-card-above-the-current-card'

      shortcutEntry ['B'], 'open-header-boards-menu', ->
        t.p ->
          t.format 'pressing-b-opens-the-boards-menu-in-the-header-you-can-search-for-boards-and-navigate-boards-with-the-up-and-down-arrows-pressing-enter-with-a-board-selected-will-open-it'

      shortcutEntry ['/'], 'focus-search-box', ->
        t.p ->
          t.format 'pressing-puts-the-cursor-in-the-search-box-in-the-header'

      shortcutEntry ['C'], 'archive-card', ->
        t.p ->
          t.format 'pressing-c-will-archive-a-card'

      shortcutEntry ['D'], 'due-date', ->
        t.p ->
          t.format 'pressing-d-will-open-the-due-date-picker-for-a-card'

      shortcutEntry ['E'], 'quick-edit-mode', ->
        t.p ->
          t.format 'if-hovering-over-a-card-pressing-e-will-open-quick-edit-mode-which-lets-you-quickly-edit-the-title-and-other-card-attributes'

      shortcutEntry ['Esc'], 'close-menu-cancel-editing', ->
        t.p ->
          t.format 'pressing-esc-will-close-an-open-dialog-window-or-pop-over-or-cancel-edits-and-comments-you-are-composing'

      shortcutEntry ['Command/Control', 'Enter'], 'save-text', ->
        t.p ->
          t.format 'meta-enter-copy'

      shortcutEntry ['Enter'], 'open-card', ->
        t.p ->
          t.format 'pressing-enter-will-open-the-currently-selected-card-pressing-shift-enter-while-submitting-a-card-will-open-it-immediately-after-creating-it'

      shortcutEntry ['F'], 'open-card-filter-menu', ->
        t.p ->
          t.format 'use-f-to-open-the-card-filter-menu-the-search-by-title-input-is-automatically-focused'

      shortcutEntry ['L'], 'label', ->
        t.p ->
          t.format 'pressing-l-opens-a-pop-over-of-the-available-labels-clicking-a-label-will-add-or-remove-it-from-the-card'

        t.p ->
          t.format 'pressing-one-of-the-following-number-keys-will-apply-or-remove-that-label'

        t.table ->
          t.thead ->
            t.tr ->
              t.th ->
                t.format 'key'
              t.th ->
                t.format 'label-color'
          t.tbody ->

            keyEntryList = (keys) ->
              for k in keys
                t.tr ->
                  t.td ->
                    t.text k[0]
                  t.td ->
                    t.format k[1]

            keys = [
              ['1', 'green']
              ['2', 'yellow']
              ['3', 'orange']
              ['4', 'red']
              ['5', 'purple']
              ['6', 'blue']
              ['7', 'sky']
              ['8', 'lime']
              ['9', 'pink']
              ['0', 'black']
            ]

            keyEntryList keys

      shortcutEntry [';'], 'label-text', ->
        t.p ->
          t.format 'shows-or-hides-label-text'

      shortcutEntry ['M'], 'add-remove-members', ->
        t.p ->
          t.format 'pressing-m-opens-the-add-remove-members-menu-clicking-a-member-s-avatar-will-assign-or-unassign-that-person'

      shortcutEntry ['N'], 'insert-new-card', ->
        t.p ->
          t.format 'pressing-n-opens-a-pop-over-that-allows-you-to-add-a-card-after-the-currently-selected-card'

      shortcutEntry [",", ".", "<", ">"], 'move-card-to-adjacent-list', ->
        t.p ->
          t.format 'pressing-period-or-comma-will-move-a-card-to-the-adjacent-left-or-right-list'

      shortcutEntry ['Q'], 'my-cards-filter', ->
        t.p ->
          t.format 'pressing-the-q-key-toggles-the-cards-assigned-to-me-filter'

      shortcutEntry ['S'], 'watch', ->
        t.p ->
          t.format 'pressing-s-will-allow-you-to-watch-or-unwatch-a-card-watching-a-card-will-notify-you-of-actions-related-to-the-card'

      shortcutEntry ['Space'], 'assign-self', ->
        t.p ->
          t.format 'pressing-space-will-assign-or-unassign-yourself-to-a-card'

      shortcutEntry ['T'], 'edit-title', ->
        t.p ->
          t.format 'if-viewing-a-card-pressing-t-will-edit-the-title-if-hovering-over-a-card-pressing-t-will-open-the-card-and-edit-the-title'

      shortcutEntry ['V'], 'vote', ->
        t.p ->
          t.format 'pressing-v-will-add-or-remove-your-vote-on-a-card-if-the-voting-power-up-is-enabled'

      shortcutEntry ['W'], 'toggle-board-menu', ->
        t.p ->
          t.format 'pressing-w-will-collapse-or-expand-the-board-menu-the-sidebar-on-the-right'

      shortcutEntry ['X'], 'clear-all-filters', ->
        t.p ->
          t.format 'use-x-to-clear-all-active-card-filters'

      shortcutEntry ['?'], 'open-shortcuts-page', ->
        t.p ->
          t.format 'pressing-will-open-the-shortcuts-page'

      shortcutEntry ['@'], 'autocomplete-members', ->
        t.p ->
          t.format 'when-writing-a-comment-you-can-type-at-plus-a-member-s-name-username-or-initials-and-get-a-list-of-matching-members-you-can-navigate-that-list-with-the-up-and-down-arrows-pressing-enter-or-tab-with-a-member-selected-will-mention-that-user-in-the-comment-the-mentioned-user-will-get-a-notification-once-submitted'

        t.p ->
          t.format 'when-adding-a-new-card-you-can-use-the-same-method-to-assign-members-to-cards-before-submitting-them'

      shortcutEntry ['#'], 'autocomplete-labels', ->
        t.p ->
          t.format 'when-adding-a-new-card-you-can-type-plus-the-label-s-color-or-title-and-get-a-list-of-matching-labels-you-can-use-the-up-and-down-arrows-to-navigate-the-resulting-list-pressing-enter-or-tab-will-add-the-label-to-the-composed-card-the-labels-will-be-added-to-the-card-when-you-submit'

      shortcutEntry ['^'], 'autocomplete-position', ->
        t.p ->
          t.format 'when-adding-a-new-card-you-can-type-plus-a-list-name-or-position-in-a-list-you-can-also-type-top-or-bottom-to-add-to-the-top-or-bottom-of-the-current-list-you-can-use-the-up-and-down-arrows-to-navigate-the-resulting-list-pressing-enter-or-tab-will-automatically-change-the-position-of-the-composed-card'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/shortcuts.coffee